// 2026-07-08 - FormuLearning - Step 4 §4.4 Next Optimization 대시보드 (F-10, 이슈 #21)
// 2026-07-23 수정 - 이슈 #50 Step4 재구성(S-4~S-6):
//   Lot 선택 드롭다운(배너·Step3 탭과 동기화) + KPI를 활성 Lot 배치에서 직접 계산
//   (iteration = 제외 아닌 배치 수, best f2 = 최대 f2). 추천은 버튼 클릭 시 후보로만
//   표시(버튼 아래)하고 **택1 확정** 시에만 opti 배치가 생성된다. 확정 배치에는
//   용출 그리드 입력을 바로 제공한다.
// 2026-08-14 수정 - 이슈 #60(M84-18): Lot 선택기 표기를 `Lot {번호}` 고정에서
//                   사용자 입력 표기(label) 대체로. lotDisplayName() 공통 규칙 적용.
// 2026-08-30 수정 - 이슈 #58 S3(#66): 후보 카드·택1 확정 UI **제거**(BR-S4-L15 폐기).
//                   `COMP-RECOMMEND-SLIDER`(1~5) 신설 — 실행하면 추천이 전량 채택되어
//                   새 optimization round 가 추가된다(BR-RND-02·03).
// 2026-08-31 수정 - 이슈 #58 S5 5차(#68, M84-75): 추천 배치 용출 그리드의 `↑ Upload`
//                   진입점 폐지. `DissolutionGrid` 가 버튼을 걷었으므로 여기 업로드 기계
//                   (파일 input·핸들러)도 함께 사라진다. 백엔드 파서는 남는다.
// 2026-08-31 수정 - 이슈 #58 S2(#65, M84-04·33·34·56·70): **활성 Lot 전환 드롭다운을
//                   걷고** 그 자리에 `COMP-REFERENCE-LOT-PICKER` 를 둔다. Step 4 의
//                   대조약 축은 추종이 아니라 **run 시점 선택**이다(BR-RND-04) — 종전
//                   드롭다운은 폐기된 `COMP-ACTIVE-LOT-BANNER` 계열이었다. 슬라이더 옆에
//                   학습 대상 2단계 선택(BR-RND-07)을 함께 둔다(UI/UX v2.2 §5.9).
// 2026-09-01 수정 - 이슈 #58 S10 3차(#70, M84-36·13): **완료 진입점을 하나로 줄인다.**
//                   `⚙️ Stop Optimization` 을 걷었다 — 정본(UI/UX v2.2 §4.9)은 완료를
//                   **화면 최하단 한 곳**만 규정하고 `M84-36` 은 *"최종 처방을 고른 뒤
//                   완료"* 를 요구하는데, 선택 없이 완료되는 경로가 남으면 요건이 그
//                   자리에서 무력화된다. `처방 지시서 다운로드` 도 여기서 걷어 **성분표
//                   아래**로 옮겼다(`M84-13` — 라운드별 처방표는 그 라운드 옆에 둔다).
// 2026-09-23 수정 - 이슈 #67 S4-4: 추천이 **작업**이 되며(202 → 진행 → 반영) `COMP-OPTIMIZATION-PROGRESS`
//                   최소판을 이 자리에 둔다(단계·경과·학습 제외·실패 시 다시 실행). KPI 5종·«AI 추천 전략: EI»
//                   라벨·신뢰도 기반 임의 제안 안내를 걷는다 — 원천 필드가 전환 창에서 없어진다(M84-35 ·
//                   BR-OPT-14, UI/UX v2.6 `COMP-KPI-CARD`).
// 2026-09-23 수정 - 이슈 #83: 진행 표시에 단계 알림·Break 를 내린다(`onJobStage`·`onJobBreak`).
// 2026-09-24 수정 - 이슈 #76(G5): ① `GridExclusionPicker` — 이번 run 의 시점·용출액 **계산 제외**(M901-29).
//                   초기값 = 직전 optimization round 의 제외(Q-260902-07 B), 추가·수정·해제 가능. 요청에 항상 명시해 싣는다.
//                   ② 결과 저장 중·미저장 편집이 있으면 Next Optimization 잠금 + 사유(M901-32, `step4PendingStore`).
//                   ③ 추천 배치 용출 뼈대 = 그 라운드 격자 − 계산 제외(`referenceFor`).
// 2026-11-02 수정 - 이슈 #101(M1002-02·09): 추천 조성 문구 — non-weight 는 mg, 중량 성분은 둘째 자리(합계 100.00 보정).
// 2026-11-03 수정 - 이슈 #114: viewer(조회 전용)는 BO 추천 실행·실행 옵션(대조약·개수·계산 제외·학습 대상) 비활성.
// 2026-11-03 수정 - 이슈 #102(M1002-05 D6): User Define 초기 설계에 X 빈칸이 있으면 Next Optimization 잠금 + 사유
//                   (서버 422 `incomplete_initial_x` 와 같은 판정 — 학습 대상 라운드·제외 배치를 반영).
// 파일 위치: frontend/src/features/step4/NextOptimizationCard.tsx

import { useState } from 'react'
import type { ExcludedBatch, OptimizeOptions } from '../../api/step4'
import type { DissolutionProfile, PhProfile, XVariable } from '../../api/step3'
import { NON_WEIGHT_MODE, incompleteInitialBatches, pctDisplay, pctToMgText, xVariableIndex } from '../../lib/composition'
import type { LotBatch, ReferenceLotCandidate } from '../../api/lot'
import type { RoundListItem } from '../../api/round'
import DissolutionGrid from '../../components/DissolutionGrid'
import LearningScopeSelector from './LearningScopeSelector'
import ReferenceLotPicker from './ReferenceLotPicker'
import OptimizationProgress, { ExcludedList, type ProgressEnd } from './OptimizationProgress'
import GridExclusionPicker from './GridExclusionPicker'
import { carriedExclusion, exclusionProblem, solutionKey, type GridExclusion } from './gridExclusion'
import { pendingReason, useStep4Pending } from '../../stores/step4PendingStore'
import { useCanWrite, READ_ONLY_TITLE } from '../../hooks/useCanWrite'

/** 추천 실패·거부 안내. `failed` 는 등록 뒤 작업이 실패한 경우(라운드·배치 무생성, BR-OPT-12). */
export interface RunError {
  message: string
  excluded?: ExcludedBatch[]
  failed?: boolean
}

interface Props {
  projectId: string
  batches: LotBatch[]
  /** 대조약 후보 — 불가 Lot 도 사유와 함께 온다(BR-RND-08). */
  referenceCandidates: ReferenceLotCandidate[]
  /** 학습 경계 선택의 1단계 축(BR-RND-07). */
  rounds: RoundListItem[]
  /** 저장된 추천 개수(1~5). 슬라이더 초기값이며 실행 시 이 값이 전송된다(BR-RND-02). */
  nRecommendations: number
  /** 실행 결과 안내 — "라운드 N 추가 · 처방 M건 생성". 후보 목록이 아니다. */
  runNotice: string | null
  /** 실행 거부(422 사유) 또는 작업 실패 안내. */
  runError: RunError | null
  /** 진행 중 추천 작업 — 있으면 진행 표시를 보이고 입력·실행을 잠근다(BR-OPT-11). */
  job: { id: string; excluded: ExcludedBatch[] } | null
  onJobEnd: (end: ProgressEnd) => void
  /** 진행 단계 알림·중단(#83) — `OptimizationProgress` 로 그대로 내린다. */
  onJobStage?: (p: { index: number; total: number; label: string }) => void
  onJobBreak?: () => void
  jobBreaking?: boolean
  onOptimize: (nRecs: number, opts: OptimizeOptions) => Promise<void>
  onSaveDissolution: (batch: LotBatch, profiles: DissolutionProfile[]) => Promise<void>
  /** 배치의 용출 입력 뼈대 — 그 라운드 격자에서 계산 제외를 뺀 대조약 프로파일(#76). */
  referenceFor: (batch: LotBatch) => PhProfile[]
  /** 등록 요청 중이거나 작업이 진행 중이다. */
  optimizing: boolean
  /** 완료 왕복 중 — 완료 버튼은 아래 `CompletionSection` 에 있으나, 그동안 새 run 을
   *  시작하지 못하게 막는다. 완료와 추천이 겹치면 어느 쪽이 마지막인지 흐려진다. */
  completing: boolean
  isCompleted: boolean
  /** 추천 조성 문구의 non-weight 판정·mg 환산(#101, M1002-02). */
  xVariables: XVariable[]
  totalWeightMg: number | null
  /** Step 3 초기 설계 알고리즘 — User Define 이면 X 빈칸이 있는 동안 실행을 막는다(#102 D6). */
  runsAlgorithm?: string | null
}

/** 추천 조성 한 줄 — 중량 성분은 둘째 자리 %(합계 100.00 보정), non-weight 는 mg(#101). */
function recommendedText(rx: Record<string, number>, xVariables: XVariable[], totalWeightMg: number | null): string {
  const varOf = xVariableIndex(xVariables)
  const isNonWeight = (k: string) => varOf(k)?.mode === NON_WEIGHT_MODE
  const d = pctDisplay(rx, isNonWeight)
  const parts = Object.entries(rx).map(([k, v]) => {
    if (isNonWeight(k)) return `${k} ${pctToMgText(v, totalWeightMg) ?? '—'} mg`
    return `${k} ${d.shown[k] ?? (typeof v === 'number' ? v.toFixed(2) : v)}%`
  })
  return parts.join(' · ')
}

export default function NextOptimizationCard({
  projectId, batches, referenceCandidates, rounds,
  nRecommendations, runNotice, runError, job, onJobEnd, onJobStage, onJobBreak, jobBreaking, onOptimize, onSaveDissolution,
  referenceFor, optimizing, completing, isCompleted, xVariables, totalWeightMg, runsAlgorithm,
}: Props) {
  // COMP-RECOMMEND-SLIDER — 이번 run 이 낼 처방 개수(1~5). 서버도 같은 범위를 강제한다.
  const [nRecs, setNRecs] = useState(Math.min(5, Math.max(1, nRecommendations)))
  // COMP-REFERENCE-LOT-PICKER — 이번 run 의 대조약(BR-RND-04). null 이면 서버가 활성 Lot 폴백.
  const [refLotId, setRefLotId] = useState<string | null>(null)
  // 학습 경계(BR-RND-07) — 기본은 전 라운드 포함·빈 제외 목록이다.
  const [roundIds, setRoundIds] = useState<string[] | null>(null)
  const [droppedBatchIds, setDroppedBatchIds] = useState<string[]>([])

  // 라운드 목록이 도착·변경되면 기본 선택(전체)을 다시 잡는다. 사용자가 이미 손댔으면
  // 그 선택을 살리되, 사라진 라운드는 떨군다 — 없는 라운드를 보내면 422 가 난다.
  const roundKey = rounds.map((r) => r.id).join(',')
  const [seededKey, setSeededKey] = useState<string | null>(null)
  // 계산 제외(#76) — null 이면 직전 optimization round 의 제외를 그대로 쓴다(이월). 라운드가 바뀌면(새 run 반영)
  //   손댄 값을 버리고 새 직전 라운드 값으로 다시 잡는다 — 방금 실행한 run 의 제외가 곧 새 기본값이다.
  const [exclusion, setExclusion] = useState<GridExclusion | null>(null)
  if (seededKey !== roundKey) {
    setSeededKey(roundKey)
    setRoundIds(null)
    setExclusion(null)
  }
  const effectiveRoundIds = roundIds ?? rounds.map((r) => r.id)
  const carried = carriedExclusion(rounds)
  const effectiveExclusion = exclusion ?? carried
  const sameAsCarried = (a: GridExclusion, b: GridExclusion) =>
    a.excluded_time_points.map(Number).sort().join(',') === b.excluded_time_points.map(Number).sort().join(',')
    && a.excluded_solutions.map(solutionKey).sort().join(',') === b.excluded_solutions.map(solutionKey).sort().join(',')

  // 저장 끝나기 전 잠금(M901-32) — 저장 중·미저장 편집 사유. 원시값 선택이라 리렌더가 늘지 않는다.
  const pendingMsg = useStep4Pending(pendingReason)
  const canWrite = useCanWrite()
  const roTitle = canWrite ? undefined : READ_ONLY_TITLE

  // 대조약 기본값 — 서버가 활성 Lot 으로 준 것을 초깃값으로 잡되 고를 수 있는 것만 잡는다.
  const defaultRef = referenceCandidates.find((c) => c.selectable)?.id ?? null
  const selectedRefId = refLotId ?? defaultRef
  // 계산 제외 칩의 원천 = 이번 run 대조약 Lot 의 격자(후보가 같은 격자만 고를 수 있게 한다, BR-RND-08)
  const refGrid = referenceCandidates.find((c) => c.id === selectedRefId)?.grid ?? null
  const gridProblem = exclusionProblem(refGrid, effectiveExclusion)
  // User Define 빈칸(#102 D6) — 서버 `build_suggest_plan` 과 같은 범위: 학습 대상 라운드 · 계산 제외·학습 제외 배치 뺌.
  const incomplete = runsAlgorithm === 'user_defined'
    ? incompleteInitialBatches(
      batches.filter((b) => !droppedBatchIds.includes(b.id)
        && (b.round_id == null || effectiveRoundIds.includes(b.round_id))),
      xVariables)
    : []
  const incompleteMsg = incomplete.length > 0
    ? `초기 설계 X 값이 비어 있는 배치 ${incomplete.length}건(${incomplete.map((b) => b.batch_code).join(', ')}) — 성분표에서 모두 입력하십시오`
    : null
  const lockMsg = pendingMsg ?? incompleteMsg
  const blocked = optimizing || completing || lockMsg !== null || gridProblem !== null || !canWrite

  // 추천됐지만 아직 결과가 없는 배치 — 용출 입력 대상(S-6).
  const pending = batches.filter((b) => b.status === 'recommended')
  const run = () => void onOptimize(nRecs, {
    referenceLotId: selectedRefId,
    roundIds: effectiveRoundIds,
    excludedBatchIds: droppedBatchIds,
    // 화면은 항상 명시한다 — 이월값도 사용자가 본 그대로 보낸다(서버의 생략 = 이월 규칙에 기대지 않는다)
    excludedTimePoints: effectiveExclusion.excluded_time_points,
    excludedSolutions: effectiveExclusion.excluded_solutions,
  })

  return (
    <div className="mb-4">
      <div className="mb-2 flex flex-wrap items-center gap-2">
        <h4 className="text-xs font-semibold uppercase tracking-wider text-text-secondary">
          Next Optimization
        </h4>
      </div>

      {/* COMP-REFERENCE-LOT-PICKER — 이 run 이 목표로 삼을 대조약(BR-RND-04·08 · M84-33·70) */}
      <ReferenceLotPicker
        candidates={referenceCandidates}
        selectedId={selectedRefId}
        onSelect={setRefLotId}
        disabled={isCompleted || optimizing || completing || !canWrite}
      />

      {/* COMP-RECOMMEND-SLIDER — 이번 run 이 낼 처방 개수(1~5, BR-RND-02) */}
      {!isCompleted && (
        <div className="mb-2 flex flex-wrap items-center gap-2">
          <label htmlFor="n-recs" className="text-[11px] text-text-secondary">추천 처방 개수</label>
          <input
            id="n-recs"
            type="range"
            min={1}
            max={5}
            step={1}
            value={nRecs}
            onChange={(e) => setNRecs(Number(e.target.value))}
            disabled={optimizing || completing || !canWrite}
            title={roTitle}
            className="w-40 accent-[var(--color-accent-purple)]"
          />
          <span className="rounded px-1.5 py-0.5 text-[11px] font-semibold"
                style={{ background: 'var(--bg-chip-purple)', color: 'var(--color-accent-purple)' }}>
            {nRecs}개
          </span>
          <span className="text-[10px] text-text-muted">
            실행하면 <b>전부 채택</b>되어 새 Optimization Round 가 추가됩니다 (고르는 단계 없음)
          </span>
        </div>
      )}

      {/* 계산 제외(M901-29 · #76) — 이번 run 이 쓸 격자. 직전 라운드 설정을 잇는다 */}
      {!isCompleted && (
        <GridExclusionPicker
          grid={refGrid}
          value={effectiveExclusion}
          onChange={setExclusion}
          carried={sameAsCarried(effectiveExclusion, carried)}
          disabled={optimizing || completing || !canWrite}
        />
      )}

      {/* 학습 대상 2단계 선택(M84-34 · BR-RND-07) — 같은 영역에 둔다(UI/UX v2.2 §5.9) */}
      {!isCompleted && rounds.length > 0 && (
        <LearningScopeSelector
          rounds={rounds}
          batches={batches}
          selectedRoundIds={effectiveRoundIds}
          excludedBatchIds={droppedBatchIds}
          onChangeRounds={setRoundIds}
          onChangeBatches={setDroppedBatchIds}
          disabled={optimizing || completing || !canWrite}
        />
      )}

      {/* Next Optimization — 완료는 화면 최하단 `CompletionSection` 한 곳이다(M84-36) */}
      {!isCompleted && (
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <button
            onClick={run}
            disabled={blocked}
            title={roTitle}
            data-testid="next-optimization"
            className="rounded bg-accent-purple px-3 py-1.5 text-[11px] font-semibold text-[#1a1b1e] transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            {optimizing ? 'Optimizing...' : '⚙️ Next Optimization'}
          </button>
          {lockMsg && !optimizing ? (
            <span className="text-[10px]" style={{ color: 'var(--color-warn)' }} data-testid="next-optimization-locked">
              🔒 {lockMsg}
            </span>
          ) : (
            <span className="text-[10px] text-text-muted">
              최적화를 끝내려면 화면 아래 <b>Optimization Completion</b> 에서 최종 처방을 고르십시오.
            </span>
          )}
        </div>
      )}

      {/* COMP-OPTIMIZATION-PROGRESS — 등록된 작업이 반영될 때까지(BR-OPT-13) */}
      {job && (
        <OptimizationProgress
          projectId={projectId} jobId={job.id} excluded={job.excluded} onEnd={onJobEnd}
          onStage={onJobStage} onBreak={onJobBreak} breaking={jobBreaking}
        />
      )}

      {/* 실행 거부(422 사유)·작업 실패 안내 — 화면이 막아도 서버가 다시 막는다. 사유를 그대로 보인다. */}
      {runError && (
        <div
          className="mb-3 rounded border px-3 py-2 text-[11px] text-text-body"
          data-testid="optimize-error"
          style={{ borderColor: 'var(--border-danger, var(--border-purple))' }}
        >
          <p>⚠ {runError.message}</p>
          {runError.failed && (
            <p className="mt-1 flex flex-wrap items-center gap-2 text-[10px] text-text-secondary">
              라운드·배치는 생기지 않았습니다.
              {!isCompleted && (
                <button
                  type="button"
                  onClick={run}
                  disabled={blocked}
                  title={roTitle}
                  className="rounded border px-2 py-0.5 text-[10px] font-semibold text-accent-purple disabled:opacity-50"
                  style={{ borderColor: 'var(--border-purple)' }}
                >
                  다시 실행
                </button>
              )}
            </p>
          )}
          <ExcludedList items={runError.excluded ?? []} />
        </div>
      )}

      {/* 실행 결과 안내(BR-RND-03) — 무엇이 생겼는지 알린다. 고를 후보는 없다. */}
      {runNotice && (
        <p
          className="mb-3 rounded border px-3 py-2 text-[11px] text-text-body"
          style={{ borderColor: 'var(--border-teal)', backgroundColor: 'var(--bg-chip-teal)' }}
        >
          ✓ {runNotice}
        </p>
      )}

      {/* 추천 배치 — 용출 프로파일 입력 + 결과 업로드(S-6) */}
      {pending.length > 0 && (
        <div className="space-y-2">
          <p className="text-[11px] text-text-secondary">
이번 라운드의 추천 처방 — 실험 후 용출 프로파일을 입력하거나 결과 파일을 업로드하십시오.
            (통합표의 행 업로드·배치 선택 입력으로도 가능합니다)
          </p>
          {pending.map((b) => (
            <div key={b.id} className="max-w-xl">
              <div className="mb-1 flex items-center gap-2">
                <span className="rounded px-1.5 py-0.5 text-[10px] font-semibold"
                      style={{ background: 'var(--bg-chip-purple)', color: 'var(--color-accent-purple)' }}>
                  {b.batch_code}
                </span>
                <span className="text-[10px] text-text-muted">
                  추천 조성: {recommendedText(b.recommended_x, xVariables, totalWeightMg)}
                </span>
              </div>
              {/* 입력은 직접 입력·붙여넣기뿐이다 — 업로드 진입점은 폐지됐다(M84-75). */}
              <DissolutionGrid
                batchLabel={b.batch_code}
                profiles={b.dissolution_profiles}
                referenceProfiles={referenceFor(b)}
                f2={b.f2}
                f2BySolution={b.f2_by_solution ?? {}}
                f2Reason={b.f2_reason}
                onSave={(profiles) => onSaveDissolution(b, profiles)}
                onDirtyChange={(d) => useStep4Pending.getState().setDirty(`diss:next:${b.id}`, d)}
              />
            </div>
          ))}
        </div>
      )}

      {pending.length === 0 && (
        <p className="text-[11px] text-text-secondary">
          {isCompleted ? 'Optimization completed.' : 'Click "Next Optimization" to get AI recommendations.'}
        </p>
      )}

    </div>
  )
}
